import { useMemo, useState } from "react";

import { TableQueryParams } from "api/common/adapters/pagination.types";
import { PaginatedResponse } from "api/common/types/response.types";
import { useDeleteProductMutation } from "api/memberPortal/product/product.api";
import { Product } from "api/memberPortal/project/product/product.types";
import ManageAMValidationTeamModal from "components/Dashboard/ProductsModule/ManageAMValidationTeamModal";
import ManageValidationTeamModal from "components/Dashboard/ProductsModule/ManageValidationTeamModal";
import ServerSidePaginatedDataGrid from "components/MUI/DataGrid/ServerSidePaginatedDataGrid";
import DeleteModal from "components/UI/DeleteModal";

import buildPineColumns from "./Pine.columns";

interface NewTableProps {
  products: PaginatedResponse<Product> | undefined;
  isFetching: boolean;
  showArchivedForm: boolean;
  filterOpen: boolean;
  drawerWidth: string;
  initialPageSize?: number;
  tableParams: TableQueryParams;
  onTableParamsChange: (_queryParams: TableQueryParams) => void;
}

const PineTable = ({
  products,
  isFetching,
  showArchivedForm,
  filterOpen,
  drawerWidth,
  tableParams,
  onTableParamsChange,
}: NewTableProps) => {
  const [triggerDelete] = useDeleteProductMutation();

  const [product, setProduct] = useState<Product | null>(null);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showValTeamModal, setShowValTeamModal] = useState(false);
  const [showAmValTeamModal, setShowAmValTeamModal] = useState(false);

  const pineColumns = useMemo(
    () =>
      buildPineColumns({
        setProduct,
        setShowDeleteModal,
        setShowAmValTeamModal,
        setShowValTeamModal,
      }),
    [],
  );

  const handleDeleteDraft = async () => {
    const id = product?.product_id ?? false;
    if (!id) return;

    await triggerDelete(id);

    setShowDeleteModal(false);
  };

  return (
    <>
      <ServerSidePaginatedDataGrid
        title={"Evaluation Projects"}
        columns={pineColumns}
        data={products}
        loading={isFetching}
        initialPaginationModel={{ page: 0, pageSize: 50 }}
        getRowId={(row) => row.v_id}
        sx={{
          flex: 1,
          mr: filterOpen ? 0 : `-${drawerWidth}`,
          alignSelf: "flex-start",
        }}
        onParamsChange={onTableParamsChange}
        columnVisibilityModel={{
          sunset_date: showArchivedForm,
        }}
        tableParams={tableParams}
      />

      {showDeleteModal && (
        // @ts-ignore this modal is a nightmare and used in far too many places to cleanup rn
        <DeleteModal
          show={showDeleteModal}
          handleClose={() => setShowDeleteModal(false)}
          type="Draft"
          deleteFunction={handleDeleteDraft}
        />
      )}

      {showValTeamModal && (
        // @ts-ignore this modal is a nightmare and used in far too many places to cleanup rn
        <ManageValidationTeamModal
          show={showValTeamModal}
          setShow={setShowValTeamModal}
          currentProductInEval={product}
        />
      )}

      {showAmValTeamModal && (
        // @ts-ignore this modal is a nightmare and used in far too many places to cleanup rn
        <ManageAMValidationTeamModal
          show={showAmValTeamModal}
          setShow={setShowAmValTeamModal}
          currentProductInEval={product}
        />
      )}
    </>
  );
};

export default PineTable;
